import getImage from './GetImage';
import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';

const consentPdf = async (data) => {

    
    pdfMake.fonts = {
        OpenSans: {
          normal: 'OpenSans-Regular.ttf',
          bold: 'OpenSans-Bold.ttf',
          italics: 'OpenSans-Italic.ttf',
          bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
          },
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
          }
      };

    const fecha = moment(new Date()).format('L');    

    let urlServe = process.env.REACT_APP_PUBLIC_URL + 'profesional/ver-firma/' + data.id_profesional + '/' + sessionStorage.getItem('token');
    let urlFirma = '';
  
    let test = fetch(urlServe)
        .then(response => {
            if (response.status === 500) {
                return false;
            } else {
                return true;
            }
        });

    let isImg = await test;

    if (isImg) {
        urlFirma = urlServe;
    } else {
        urlFirma = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        info: {            
            author: "Josue Hurtado",
        },
        content: [
            {
                // auto-sized columns have their widths based on their content                                       
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['*', 270, 60, 70],
                    headerRows: 1,
                    body: [
                        [{
                            rowSpan: 5,
                            image: await getImage(data.urlLogo),
                            fit: [100, 40],    
                        },
                        { rowSpan: 5, text: 'CONSENTIMIENTO INFORMADO Y ACEPTACIÓN DE SERVICIO PRESTADO', alignment: 'center' },
                        { text: 'CODIGO' },
                        { text: 'FT-IM-40' }
                        ],
                        ['', '', { text: 'CREACIÓN' }, { text: '24/08/2016' }],
                        ['', '', { text: 'VERSIÓN' }, { text: '2' }],
                        ['', '', {text: 'PAGINA', rowSpan: 2,} , {text: '1 de 1', rowSpan: 2,} ],
                        ['', '', '' , ''],
                    ]
                },
            },
            {
                text: 'DECLARACIÓN DEL PACIENTE ', style: 'tableheader', alignment: 'center', margin:[0,10]
            },
            {
                text: 'Fecha ' + fecha +' Nombre y Apellidos ' + data.names  , style: 'tableheader', alignment: 'center', margin:[0,3]
            },
            {
                text: 'Documento de identidad ' + data.typeOfDocument + ' ' + data.documentNumber, style: 'tableheader', alignment: 'center', margin:[0,3]
            },
            {
                text: data.gender === "Femenino" ? 'SE ENCUENTRA EN ESTADO DE EMBARAZO SÍ__ NO__' : "", style: 'tableheader', alignment: 'center', margin:[0,10]
            },
            {
                text: '1- Dejo constancia que se me ha explicado y he comprendido claramente la naturaleza y propsitos de este precedimiento, aceptandolo. No tengo dudas y me han sido informados los posibles riesgos y complicaciones.', style: 'paragraf', margin:[0,5]
            },
            {
                text: '2- Manifiesto mi consentimiento para que se me efectue el procedimeinto ' + data.servName + ' e imagenes adicionales que sean necesario durante la realización del mismo.', style: 'paragraf', margin:[0,5]
            }, 
            {
                text: '3- Entiendo que de no aceptar el tratamiento o procedimiento aqui propuesto, sere remitido a mí médico tratante para que tome otra alternativa de procedimiento y/o tratamiento.', style: 'paragraf', margin:[0,5]
            },  
            {
                text: '4- Autorizo para que '+   data.profile.nombre +' Obtenga mis imagenes y la información médica para uso educativo, cientifico y/o para investigaciones en general sin que para ellos sea divulgado mi nombre identidad. (información médica protegida con fines de investigación)', style: 'paragraf', margin:[0,5]
            },
            {
                text: '5- Confirmo la presentacion efectiva del procedimiento '  + data.servName + ' dando cumplimiento a la resolucion 3047 de 2008 en su anexo tecnico No. 5.', style: 'paragraf', margin:[0,5]
            },
            {
                text:'6- Dejo constacia que he entendido y comprendido mis derecho y deberes como paciente.' , style: 'paragraf', margin:[0,5]
            },
            {
                text:'Nota: Firmará por el paciente (menores de edad y pacientes en estado critico), su representante legal y/o responsable en aquellos casos en que el usuario no este en capacidad de tomar pos is mismo la desicion de aceptar o rechazar el procedimiento y/o tratamiento descrito por el Médico nuclear y/o Tecnólogo.', style: 'paragraf', margin:[0,5,0,10]
            },
            {
                text:'Firma paciente / familiar Responsable: ____________________________________' , style: 'paragraf', margin:[0,5]
            },    
            {
                text:'Documento de identidad: ____________________________________________________' , style: 'paragraf', margin:[0,3]
            },  
            {
                text:'Firma familiar y/o Responsable: ________________________________________' , style: 'paragraf', margin:[0,20,0,3]
            },  
            {
                text:'Parentesco: _______________________________________________________________' , style: 'paragraf', margin:[0,3]
            },   
            {
                text:'Documento de identidad: ___________________________________________________' , style: 'paragraf', margin:[0,3]
            },               
            {                                                    
                columns: [
                    {
                        // auto-sized columns have their widths based on their content                                       
                        margin: [40, 20, 25, 0],
                        layout: 'headerLineOnly',
                        table: {
                            widths: [120],
                            headerRows: 1,
                            body: [
                                [''],
                                [{ text: 'Firma Tecnologo', style: 'textStyle', }],

                            ]
                        },
                    },
                    {
                        // auto-sized columns have their widths based on their content                                       
                        margin: [40, 20, 25, 0],
                        layout: 'headerLineOnly',
                        table: {
                            widths: [120],
                            headerRows: 1,
                            body: [
                                [ {                                    
                                    image: await getImage(urlFirma),
                                    fit: [80, 80],
                                }],
                                [{ text: 'Firma del Medico', style: 'textStyle', }],

                            ]
                        },
                    },
                ],
                columnGap: 20
            },    
        ],
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            tableheader: {
                fontSize: 11,
                bold: true,
            },
            textStyle: {
                fontSize: 9,
            },
            signature: {
                fontSize: 8,
                alignment: 'center',
                bold: true
            },
            foter: {
                margin: 10,
                fontSize: 6,
            },
            medicStyle: {
                margin: [0, 80, 0, 0],
                fontSize: 10,
                alignment: 'left',
            },
            paragraf: {
                fontSize: 10,
                alignment: 'justify'
            },
        }
    };

    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

export default consentPdf;